import { useRef, useState } from 'react';

/**
 * Hook for managing breadcrumb menu state with ref-based anchoring.
 * Provides consistent menu behavior across all breadcrumb components.
 */
export default function useBreadcrumbMenu() {
    const [isOpen, setIsOpen] = useState(false);
    const anchorRef = useRef<HTMLButtonElement>(null);

    const open = () => setIsOpen(true);
    const close = () => setIsOpen(false);

    const menuProps = {
        anchorEl: anchorRef.current,
        open: isOpen && Boolean(anchorRef.current),
        onClose: close,
        anchorOrigin: {
            vertical: 'bottom' as const,
            horizontal: 'left' as const,
        },
        transformOrigin: {
            vertical: 'top' as const,
            horizontal: 'left' as const,
        },
        slotProps: {
            paper: {
                sx: {
                    minWidth: 250,
                    overflow: 'hidden',
                },
            },
        },
    };

    const buttonProps = {
        ref: anchorRef,
        active: isOpen,
        onClick: open,
    };

    return {
        anchorRef,
        isOpen,
        open,
        close,
        menuProps,
        buttonProps,
    };
}
